import type { Bloque as BloqueTipo } from '../domain/types';

/**
 * Un bloque se pinta según su tipo.
 *
 * Los tipos que todavía no se implementan AVISAN en pantalla en vez de romperla: en fase 1
 * el CMS podrá crear un bloque de un tipo que esta versión de la app no conoce, y una
 * pantalla en blanco no le dice nada a nadie.
 *
 * Sobre `dangerouslySetInnerHTML`: hoy el contenido lo escribe el equipo de Treid y viaja
 * en el propio bundle, así que no hay entrada de terceros. En fase 1, cuando el CMS deje
 * escribir HTML a un coordinador, hay que sanear la entrada EN EL CMS.
 */
export function Bloque({ bloque }: { bloque: BloqueTipo }) {
  const c = bloque.contenido;

  switch (bloque.tipo) {
    case 'texto':
      return (
        <div
          className="prose-academia"
          dangerouslySetInnerHTML={{ __html: String(c.html ?? '') }}
        />
      );

    case 'presentacion':
      if (typeof c.html === 'string') {
        return (
          // overflow-x-auto: el SVG es ancho y en celular debe hacer scroll DENTRO de su
          // caja, no empujar la página entera.
          <div className="ilustracion my-5 overflow-x-auto rounded-2xl">
            <div dangerouslySetInnerHTML={{ __html: c.html }} />
          </div>
        );
      }
      return <Pendiente que="Esta presentación" />;

    case 'imagen':
      return (
        <img
          src={String(c.storagePath ?? '')}
          alt={String(c.alt ?? '')}
          className="my-5 w-full rounded-2xl"
          loading="lazy"
        />
      );

    case 'video_youtube':
      return (
        <div className="my-5 aspect-video w-full overflow-hidden rounded-2xl bg-black">
          <iframe
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${String(c.videoId ?? '')}`}
            title="Video de la lección"
            allow="accelerometer; clipboard-write; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      );

    case 'documento':
      return <Pendiente que="Este material descargable" />;

    case 'video_archivo':
      return <Pendiente que="Este video" />;

    default:
      return <Pendiente que="Este contenido" />;
  }
}

function Pendiente({ que }: { que: string }) {
  return (
    <p className="my-5 rounded-xl border border-dashed border-borde px-4 py-5 text-center text-sm text-gris">
      {que} estará disponible próximamente.
    </p>
  );
}
